import React from 'react';

const About = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <section className="section">
        <div className="container">
          <h1 className="section-title">About MEES HOLDINGS INC</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Company Overview</h2>
            <p style={{marginBottom: '2rem'}}>
              MEES HOLDINGS INC is an authorized reseller of SMS marketing services, established to help businesses 
              connect with their customers through compliant and effective text messaging campaigns. Based in 
              Brooklyn, New York, we partner with leading SMS service providers to deliver professional-grade 
              messaging solutions to businesses across the United States.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Our Mission</h2>
            <p style={{marginBottom: '2rem'}}>
              To provide businesses with reliable, compliant, and effective SMS marketing solutions through our 
              partnerships with leading SMS service providers. We drive customer engagement and business growth 
              while maintaining the highest standards of regulatory compliance and data security.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Company Information</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <p><strong>Legal Name:</strong> MEES HOLDINGS INC</p>
              <p><strong>Business Address:</strong> 2022 E 9TH ST, BROOKLYN, NY 11223</p>
              <p><strong>Employer Identification Number (EIN):</strong> 93-4196857</p>
              <p><strong>Website:</strong> https://meesmarketing.com/</p>
              <p><strong>Business Type:</strong> SMS Marketing Services Reseller</p>
              <p><strong>Founded:</strong> 2020</p>
              <p><strong>Business Structure:</strong> New York Corporation</p>
              <p><strong>Industry:</strong> Digital Marketing & Communications</p>
              <p><strong>Owner:</strong> Esther Buaki</p>
              <p><strong>Technical Lead:</strong> Biswanath Sahoo</p>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Business Operations & Services</h2>
            <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '1px solid #3b82f6'}}>
              <h3 style={{color: '#1e40af', marginBottom: '1rem'}}>Core Business Activities</h3>
              <ul style={{marginBottom: '1rem', paddingLeft: '2rem'}}>
                <li>Reselling SMS Marketing Services</li>
                <li>A2P (Application-to-Person) Messaging Campaign Management</li>
                <li>TCPA & CAN-SPAM Compliance Consulting</li>
                <li>Customer Engagement Solutions</li>
                <li>Marketing Automation Support</li>
                <li>Business Communication Consulting</li>
              </ul>
              
              <h3 style={{color: '#1e40af', marginBottom: '1rem'}}>Target Markets</h3>
              <ul style={{paddingLeft: '2rem'}}>
                <li>E-commerce & Retail Businesses</li>
                <li>Healthcare & Medical Practices</li>
                <li>Real Estate Agencies</li>
                <li>Automotive Dealerships</li>
                <li>Financial Services</li>
                <li>Professional Services</li>
              </ul>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Our Expertise</h2>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Application-to-Person (A2P) SMS campaign management</li>
              <li>TCPA and CAN-SPAM compliance consulting</li>
              <li>Partnership with tier-1 SMS service providers</li>
              <li>Campaign optimization and analytics</li>
              <li>Customer consent management</li>
              <li>Message delivery coordination</li>
              <li>Regulatory compliance guidance</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Industry Compliance & Certifications</h2>
            <div style={{background: '#f0fdf4', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '1px solid #16a34a'}}>
              <p style={{marginBottom: '1rem', fontWeight: '600', color: '#16a34a'}}>
                MEES HOLDINGS INC maintains strict compliance with all applicable regulations:
              </p>
              <ul style={{paddingLeft: '2rem'}}>
                <li><strong>TCPA Compliant:</strong> Full adherence to Telephone Consumer Protection Act</li>
                <li><strong>CAN-SPAM Certified:</strong> Complete compliance with anti-spam regulations</li>
                <li><strong>A2P Ready:</strong> Preparing for Application-to-Person registration with carriers</li>
                <li><strong>Trusted Partners:</strong> Working with established SMS service providers</li>
                <li><strong>Data Protection:</strong> Strong data security and privacy practices</li>
                <li><strong>Privacy Compliant:</strong> CCPA and privacy law adherent practices</li>
              </ul>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Business Infrastructure</h2>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem', marginBottom: '2rem'}}>
              <div style={{background: '#f8fafc', padding: '1.5rem', borderRadius: '8px'}}>
                <h4 style={{color: '#1e40af', marginBottom: '0.5rem'}}>Service Platform</h4>
                <p style={{fontSize: '0.95rem'}}>Partnering with enterprise-grade SMS providers to deliver reliable messaging with real-time analytics.</p>
              </div>
              <div style={{background: '#f8fafc', padding: '1.5rem', borderRadius: '8px'}}>
                <h4 style={{color: '#1e40af', marginBottom: '0.5rem'}}>Support Team</h4>
                <p style={{fontSize: '0.95rem'}}>Dedicated support team, account management, and compliance guidance for all clients.</p>
              </div>
              <div style={{background: '#f8fafc', padding: '1.5rem', borderRadius: '8px'}}>
                <h4 style={{color: '#1e40af', marginBottom: '0.5rem'}}>Security & Privacy</h4>
                <p style={{fontSize: '0.95rem'}}>Strong data protection practices, secure handling of customer information, and privacy compliance.</p>
              </div>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Our Commitment</h2>
            <p style={{marginBottom: '2rem'}}>
              We are committed to providing transparent, reliable, and compliant SMS marketing services through 
              our partnerships with leading SMS providers. Our team works diligently to ensure that all campaigns 
              meet regulatory requirements while delivering exceptional results for our clients. We believe in 
              building long-term partnerships based on trust, performance, and mutual success.
            </p>

            <div style={{background: '#2563eb', color: 'white', padding: '2rem', borderRadius: '10px', textAlign: 'center'}}>
              <h3>Ready to Work With Us?</h3>
              <p>Contact MEES HOLDINGS INC today to learn how we can help grow your business with compliant SMS marketing.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;